/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, April 13th 2022, 6:21:11 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { useDefaultProcessTemplateArtifact } from "common/hooks";
import { ProcessDefinitionGeneralInfoForm } from "service-builder";
import { useToggleState } from "ui-widgets/dialogs/useToggleState";
import { getDefaultProcessDefinition } from "lib/factories";

export const ProcessDefinitionInfoButtonWrapper = ({ children }) => {
  const {
    open: processDefinitionGeneralInfoPopupOpenState,
    handleClose: closeProcessDefinitionGeneralInfoPopupFn,
    handleOpen: openProcessDefinitionGeneralInfoPopupFn,
  } = useToggleState();

  const { artifact_org } = useDefaultProcessTemplateArtifact();
  const defaultNewProcessDefinition = getDefaultProcessDefinition({ organizationId: artifact_org });

  return (
    <>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, { onClick: openProcessDefinitionGeneralInfoPopupFn })
      )}
      <ProcessDefinitionGeneralInfoForm
        processDefinitionGeneralInfoFormOpenState={processDefinitionGeneralInfoPopupOpenState}
        closeProcessDefinitionGeneralInfoForm={closeProcessDefinitionGeneralInfoPopupFn}
        processDefinition={defaultNewProcessDefinition}
      />
    </>
  );
};
